export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

/**
 * Importe tecleado a numero. Acepta coma o punto decimal; vacio o invalido es 0.
 * Los campos son de texto y no type="number": en algunos navegadores un
 * type="number" devuelve '' ante una coma, y el importe se quedaba en 0 aunque
 * el cuadro mostrara lo escrito.
 */
export const parseAmount = (text: string): number => {
  const value = parseFloat(String(text || '').replace(',', '.'));
  return isNaN(value) ? 0 : value;
};

/** Deja solo digitos y un separador decimal (coma o punto). */
export const sanitizeAmountInput = (text: string): string => {
  const cleaned = text.replace(/[^0-9.,]/g, '');
  const firstSep = cleaned.search(/[.,]/);
  if (firstSep === -1) return cleaned;
  return cleaned.slice(0, firstSep + 1) + cleaned.slice(firstSep + 1).replace(/[.,]/g, '');
};

